import React from 'react'
import { Link } from 'react-router-dom'

export default function Reports() {
    // Per-company feature flag (core.Configuration). The QA Time Tracking report
    // is eMedHub-specific, so only companies with the flag enabled see the card.
    let qaTimeTrackingEnabled = false;
    try {
        qaTimeTrackingEnabled = JSON.parse(localStorage.getItem('qaTimeTrackingEnabled')) === true;
    } catch {
        qaTimeTrackingEnabled = false;
    }

    let ReportsList = [
        { label: "Overall Report", key: "overall", path: "/Reports/OverallReports" },
        { label: "Requirement TAT Report", key: "overall", path: "/Reports/ClientTATReport" },
        { label: "Sprint Performance Report", key: "overall", path: "/Reports/QAFailsReport" },
        { label: "Branch Audit Report", key: "branchAudit", path: "/Reports/BranchAudit" },
        ...(qaTimeTrackingEnabled
            ? [{ label: "QA Time Tracking", key: "qaTimeTracking", path: "/Reports/QATimeTracking" }]
            : []),
        // { label: "Sprint Performance Report", key: "sprintPerformance", path: "/Reports/SprintPerformance" },
        // { label: "QA Performance Report", key: "qaPerformance", path: "/Reports/QAPerformance" },
    ]

    return (
        <div>
            <h2 style={{ marginLeft: "45px", marginTop: "25px", fontSize: '25px' }}>Reports</h2>
            <div className="master-grid-container" style={{ backgroundColor: "black"}}>
                {ReportsList.map((item) => (
                    <Link 
                        key={item.key} 
                        to={item.path} 
                        className="master-card" 
                        style={{ textDecoration: 'none', height:"3dvw" }}
                    >
                        <div style={{fontSize:"0.9vw"}}>{item.label}</div>
                    </Link>
                ))}
            </div>
        </div>
    )
}